<template>
  <div id="premiumContent" ref="premiumContent">
    <vx-card class="w-full mb-3">
      <div class="vx-row mb-2">
        <vs-tabs v-model="activeTab">
          <vs-tab label="Stuctured Lessons & Standalone Tasks">
            <div class="tab-text">
            </div>
          </vs-tab>
          <vs-tab label="Additional Resources">
            <div class="tab-text">
            </div>
          </vs-tab>
        </vs-tabs>
      </div>

      <div v-if="activeTab == 0"  class="vx-row">
        <div class="vx-col xs:w-full sm:w-full md:w-1/2 lg:w-1/3 xl:w-1/3 w-full">
          <div class="mb-3">
            <h5>Language</h5>
            <v-select ref="langDropdown" placeholder="Search / Select Language"  @search:blur.once="searchLang" :options="languageListFilter" v-model="langDropdown"></v-select>
          </div>
        </div>
        <div class="vx-col xs:w-full sm:w-full md:w-1/2 lg:w-1/3 xl:w-1/3 w-full">
          <div class="mb-3">
            <h5>Grade</h5>
            <v-select :disabled="!langDropdown" ref="gradeDropdown" placeholder="Search / Select Grade"  @search:blur.once="searchGrade" :options="gradeListFilter" v-model="gradeDropdown"></v-select>
          </div>
        </div>
        <div class="vx-col xs:w-full sm:w-full md:w-1/2 lg:w-1/3 xl:w-1/3 w-full">
          <div class="mb-3">
            <h5>Subject</h5>
            <v-select :disabled="!gradeDropdown || !langDropdown" ref="subjectDropdown" placeholder="Search / Select Subject"  @search:blur.once="searchSubject" :options="gradeDropdown ? subjectListFilter : emptyList" v-model="subjectDropdown"></v-select>
          </div>
        </div>
      </div>
      
      <div v-show="activeTab == 1" class="vx-row">
        <div class="vx-col xs:w-full sm:w-full md:w-1/2 lg:w-1/3 xl:w-1/3 w-full">
          <div class="mb-3">
            <h5>Category</h5>
            <v-select ref="catDropdown" placeholder="Search / Select Category" :options="catList" v-model="catDropdown"></v-select>
          </div>
        </div>
        <div class="vx-col xs:w-full sm:w-full md:w-1/2 lg:w-1/3 xl:w-1/3 w-full">
          <div class="mb-3">
            <h5>Term</h5>
            <v-select ref="termDropdown" placeholder="Search / Select Category" :options="termList" v-model="termDropdown"></v-select>
          </div>
        </div>
        <div class="vx-col xs:w-full sm:w-full md:w-1/2 lg:w-1/3 xl:w-1/3 w-full">
          <div class="mb-3">
            <h5>Grade</h5>
            <v-select ref="resourceGradeDropDown" placeholder="Search / Select Grade" :options="resourceGradeList" v-model="resourceGradeDropDown"></v-select>
          </div>
        </div>
        <div class="vx-col xs:w-full sm:w-full md:w-1/2 lg:w-1/3 xl:w-1/3 w-full">
          <div class="mb-3">
            <h5>Resource</h5>
            <v-select ref="resourceDropdown" placeholder="Search / Select Resource" :options="generateResourceDropDown" v-model="resourceDropdown"></v-select>
          </div>
        </div>
      </div>
    </vx-card>

    <vx-card title="Content" v-if="showTaskTable && activeTab == 0 && (gradeDropdown && langDropdown && subjectDropdown)" class="w-full mb-3">
      <vs-table ref="premiumList" stripe class="vs-con-loading__container" single pagination :max-items="tasksPerPage" search :data="taskList">
        <div slot="header" class="vx-row flex flex-wrap-reverse items-center flex-grow">
          
          <!-- ITEMS PER PAGE -->
          <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 vx-col s:w-1/3 xs:w-full sm:w-full md:w-1/3 lg:w-1/4 xl:w-1/6">
            <div class="p-4 border border-solid border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium" >
              <span class="mr-2">{{ currentTaskPage * tasksPerPage - (tasksPerPage - 1) }} - {{ taskList.length - currentTaskPage * tasksPerPage > 0 ? currentTaskPage * tasksPerPage : taskList.length }} of {{ taskList.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
            </div>
              <vs-dropdown-menu>
                <vs-dropdown-item @click="tasksPerPage=10">
                  <span>10</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="tasksPerPage=15">
                  <span>15</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="tasksPerPage=20">
                  <span>20</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="tasksPerPage=25">
                  <span>25</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="tasksPerPage=50">
                  <span>50</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="tasksPerPage=100">
                  <span>100</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <template slot="thead">
          <vs-th sort-key="module">Module</vs-th>
          <vs-th sort-key="term">Term</vs-th>
          <vs-th sort-key="type">Type</vs-th>
          <vs-th sort-key="taskName">Task Name</vs-th>
          <vs-th sort-key="isPremium"> Premium</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="task" :key="indextr" v-for="(task, indextr) in data">

            <vs-td :data="data[indextr].module">
              {{ task.module }}
            </vs-td>

            <vs-td :data="data[indextr].term">
              {{ task.term }}
            </vs-td>

            <vs-td :data="data[indextr].type">
              {{ task.type }}
            </vs-td>

            <vs-td :data="data[indextr].taskName">
              {{ task.taskName }}
            </vs-td>

            <vs-td :data="data[indextr].isPremium">
              <vs-checkbox
                color="success"
                v-model="task.isPremium"
                @click="markTaskAsPremium(task)">
              </vs-checkbox>
            </vs-td>

          </vs-tr>
        </template>
      </vs-table>
    </vx-card>

    <vx-card title="Content" v-if="showResourceTable && activeTab == 1" class="w-full mb-3">
      <vs-table ref="premiumList" stripe class="vs-con-loading__container" single pagination :max-items="tasksPerPage" search :data="resourceTaskList">
        <div slot="header" class="vx-row flex flex-wrap-reverse items-center flex-grow">
          
          <!-- ITEMS PER PAGE -->
          <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 vx-col s:w-1/3 xs:w-full sm:w-full md:w-1/3 lg:w-1/4 xl:w-1/6">
            <div class="p-4 border border-solid border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium" >
              <span class="mr-2">{{ currentTaskPage * tasksPerPage - (tasksPerPage - 1) }} - {{ taskList.length - currentTaskPage * tasksPerPage > 0 ? currentTaskPage * tasksPerPage : taskList.length }} of {{ taskList.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
            </div>
              <vs-dropdown-menu>
                <vs-dropdown-item @click="tasksPerPage=10">
                  <span>10</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="tasksPerPage=15">
                  <span>15</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="tasksPerPage=20">
                  <span>20</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="tasksPerPage=25">
                  <span>25</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="tasksPerPage=50">
                  <span>50</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="tasksPerPage=100">
                  <span>100</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <template slot="thead">
          <vs-th sort-key="module">Module</vs-th>
          <vs-th sort-key="term">Term</vs-th>
          <vs-th sort-key="type">Grade</vs-th>
          <vs-th sort-key="taskName">Resource Category</vs-th>
          <vs-th sort-key="isPremium"> Premium</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="task" :key="indextr" v-for="(task, indextr) in data">

            <vs-td :data="data[indextr].module">
              {{ task.module }}
            </vs-td>

            <vs-td :data="data[indextr].term">
              {{ task.term }}
            </vs-td>

            <vs-td :data="data[indextr].grade">
              {{ task.grade }}
            </vs-td>

            <vs-td :data="data[indextr].resourceCategory">
              {{ task.resourceCategory }}
            </vs-td>

            <vs-td :data="data[indextr].isPremium">
              <vs-checkbox
                color="success"
                v-model="task.isPremium"
                @click="markTaskAsPremium(task)">
              </vs-checkbox>
            </vs-td>

          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  export default {
    components:{
      'v-select': vSelect
    },
    data() {
      return {
        langDropdown:null,
        languageList:[],
        languageListFilter:[],
        gradeDropdown:null,
        gradeList:[],
        gradeListFilter:[],
        subjectDropdown:null,
        subjectList:[],
        subjectListFilter:[],
        emptyList:[],
        currentTaskPage:1,
        tasksPerPage:10,
        taskList:[],
        showTaskTable:false,
        prevSelectedLang:null,
        prevSelectedGrade:null,
        catDropdown:null,
        catList:[],
        catListFilter:[],
        resourceDropdown:null,
        resourceList:[],
        resourceListFilter:[],
        activeTab:0,
        showResourceTable:false,
        gradeDropdownResource:null,
        termDropdown: null,
        termList:[],
        resourceGradeList:[],
        resourceGradeDropDown:null,
        resourceTaskList:[],
      }
    },
    watch: {
      langDropdown:function(){
        var self = this;
        if(self.langDropdown){
          self.subjectDropdown = null;
          self.gradeDropdown = null;
          self.getGradeList(parseInt(self.langDropdown.value));
        }
        else{
          self.subjectDropdown = null;
          self.gradeDropdown = null;
        }
      },
      gradeDropdown:function(){
        var self = this;
        if(self.gradeDropdown){
          self.subjectDropdown = null;
          var lang = parseInt(self.langDropdown.value);
          var grade = parseInt(self.gradeDropdown.value);
          self.subjectListFilter = self.subjectList.filter(x=>x.courseClassificationId == grade && x.languageId ==lang);
          self.subjectListFilter = self.subjectListFilter.map(x=>{return{label:x.name, value:x.id}});
        }
        else{
          self.subjectDropdown = null;
        }
      },
      subjectDropdown:function(){
        var self = this;
        if(self.subjectDropdown){
          self.getTasks();
        }
      },
      activeTab:function(){
        var self = this;
        if(self.activeTab == 1){
          if(self.resourceDropdown){
            self.showTaskTable = false;
            self.showResourceTable = true;
          }
          else{
            self.getResources();
            self.getCategory();
            self.getTermData();
            self.getGradeData();
          }
        }
        if(self.activeTab == 0){
          if(self.subjectDropdown){
            self.showTaskTable = true;
            self.showResourceTable = false;
          }
          else{
            self.showTaskTable = false;
            self.showResourceTable = false;
          }

        }
      },
      resourceDropdown:function(){
        var self = this;
        if(self.resourceDropdown){
          self.getTasksforResources();
        }
        else{
          self.showResourceTable = false;
        }
      },
    },
    computed: {
      generateResourceDropDown(){
        var self= this;
        var dataList = self.resourceList;
        if(self.catDropdown){
          dataList = dataList.filter(x=>x.resourceCategoryId == parseInt(self.catDropdown.value));
        }
        if(self.termDropdown){
          dataList = dataList.filter(x=>x.termId == parseInt(self.termDropdown.value));
        }
        if(self.resourceGradeDropDown){
          dataList = dataList.filter(x=>x.gradeId == parseInt(self.resourceGradeDropDown.value));
        }
        if(dataList.length == 0){
          self.resourceDropdown = null;
        }

        dataList = dataList.map(x=>{return{label:x.module,value:x.moduleId}});
        return dataList;
      }
    },
    methods: {
      initValues(){
        var self = this;
        self.langDropdown=null;
        self.languageList=[];
        self.languageListFilter=[];

        self.gradeDropdown=null;
        self.gradeList=[];
        self.gradeListFilter=[];

        self.subjectDropdown=null;
        self.subjectList=[];
        self.subjectListFilter=[];

      },
      showLoadingOnElement(element, scale, type) {
        var self = this;
        self.$vs.loading({
          type: type,
          container: self.$refs[element].$el,
          scale: scale
        });
      },
      getLangList(){
        var self = this;
        self.showLoadingOnElement("langDropdown", 0.35, "corners");
        var onSuccess = response =>{
          self.languageList = response.data.map((item) => {return {label: item.text, value: item.value} });
          self.languageListFilter = self.languageList;
        }
        var onFinally = response=>{
          self.$vs.loading.close(self.$refs.langDropdown.$el);
        }
        self.$ajaxGet(self, "language/GetSelectList", onSuccess, onFinally);
      },
      searchLang(search){
        var self = this;
        if(search){
          self.languageListFilter = self.languageListFilter.filter(x=>x.label.search(search));
        }
        else{
          self.languageListFilter = self.languageList;
        }
      },
      getGradeList(languageId){
        var self = this;
        self.showLoadingOnElement("gradeDropdown", 0.35, "corners");

        var onSuccess = response =>{
          self.gradeList = response.data.map(x=> {return{label:x.text, value:x.value}});
          self.gradeListFilter = self.gradeList;
        }
        var onFinally = () =>{
          self.$vs.loading.close(self.$refs.gradeDropdown.$el);
        }
        self.$ajaxGet(self, "courseclassification/GetSelectList/" + languageId, onSuccess, onFinally);
      },
      searchGrade(search){
        var self = this;
        if(search){
          self.gradeListFilter = self.gradeListFilter.filter(x=>x.label.search(search));
        }
        else{
          self.gradeListFilter = self.gradeList;
        }
      },
      searchSubject(search){
        var self = this;
        if(search){
          self.subjectListFilter = self.subjectListFilter.filter(x=>x.label.search(search));
        }
        else{
        }
      },
      getCourseList(){
        var self = this;
        var onSuccess = response =>{
          self.subjectList = response.data;
          self.subjectListFilter = self.subjectList.map(x=>{return{label:x.name, value:x.id}});
        };
        self.$ajaxGet(self,"Course/ListCourses" ,onSuccess);
      },
      getTasks(){
        var self = this;
        self.showLoadingOnElement("premiumContent",1,"corners");

        var onSuccess = response =>{
          self.taskList = response.data;
          self.showTaskTable = true;
        };

        var onFinally = response =>{
          self.$vs.loading.close(self.$refs.premiumContent.$el);
        };

        self.$ajaxGet(self,"Module/PremiumContentList?subjectId="+self.subjectDropdown.value , onSuccess, onFinally);
        
      },
      markTaskAsPremium(data){
        var self = this;
        if(data.taskId){
          self.$ajaxPost(self,"Module/MarkTaskAsPremium?premiumTaskId="+data.taskId);
        }
        else{
          self.$ajaxPost(self,"Module/MarkModuleAsPremium?premiumModuleId="+data.moduleId);
        }
      },
      getCategory(){
        var self = this;
        self.showLoadingOnElement("catDropdown",0.35,"corners");

        var onSuccess = response =>{
          self.catList = response.data.map(x=>{return{label:x.text,value:x.value}});
        };
        
        var onFinally = response =>{
          self.$vs.loading.close(self.$refs.catDropdown.$el);
        };
        self.$ajaxGet(self,"ResourceCategory/List",onSuccess,onFinally)
      },
      getTermData(){
        var self = this;
        self.showLoadingOnElement("termDropdown",0.35,"corners");

        var onSuccess = response=>{
          self.termList = response.data.map(x=>{
            return{label: x.name, value: x.id}
          });
        };

        var onFinally = response=>{
          self.$vs.loading.close(self.$refs.termDropdown.$el);
        }

        self.$ajaxGet(self, "ModuleGroup/ListModuleGroups", onSuccess,onFinally);
      },
      getGradeData(){
        var self = this;
        self.showLoadingOnElement("resourceGradeDropDown",0.35,"corners");

        var onSuccess = response=>{
          self.resourceGradeList = response.data.map(x=>{
            return{label: x.name, value: x.id}
          });
        };

        var onFinally = response=>{
          self.$vs.loading.close(self.$refs.resourceGradeDropDown.$el);
        }

        self.$ajaxGet(self, "CourseClassification/ListClassifications", onSuccess,onFinally);
      },
      getResources(){
        var self = this;
        self.showLoadingOnElement("resourceDropdown",0.35,"corners");

        var onSuccess = response =>{
          self.resourceList = response.data;
        };
        
        var onFinally = response =>{
          self.$vs.loading.close(self.$refs.resourceDropdown.$el);
        };
        self.$ajaxGet(self,"AdditionalResources/GetResources" ,onSuccess,onFinally)
      },
      getTasksforResources(){
        var self = this;
        self.showLoadingOnElement("premiumContent",1,"corners");

        var onSuccess = response =>{
          self.resourceTaskList = response.data;
        };
        
        var onFinally = response =>{
          self.showResourceTable = true;
          self.$vs.loading.close(self.$refs.premiumContent.$el);
        };
        self.$ajaxGet(self,"AdditionalResources/tasksForPremium?resourseId=" + self.resourceDropdown.value ,onSuccess,onFinally)
      }
    },
    mounted() {
      var self = this;
      self.initValues();
      self.getLangList();
      self.getCourseList();
    },
  }

</script>
<style lang="scss">


</style>
